import React from 'react';
import { Menu } from '@headlessui/react';
import { HiChevronUpDown } from "react-icons/hi2";

const styles = [
  { 
    label: 'Default', 
    value: 'realistic', 
    image: 'https://imagedelivery.net/Ze5D2t9VVJMFNTqhCbpFZg/00d53d79-aeb1-4f81-165c-3978764e4a00/public' 
  },
  { 
    label: 'Dark Fantasy', 
    value: 'darkf', 
    image: 'https://imagedelivery.net/Ze5D2t9VVJMFNTqhCbpFZg/c05a7964-da80-46f2-7f42-1c9b6521ae00/public'
  },
  { 
    label: 'Ancient Civilization', 
    value: 'ancient', 
    image: 'https://imagedelivery.net/Ze5D2t9VVJMFNTqhCbpFZg/5e068fa7-f8fa-4867-f2c4-826e0a9fe500/public'
  },
  { 
    label: '3D Animation', 
    value: '3d', 
    image: 'https://imagedelivery.net/Ze5D2t9VVJMFNTqhCbpFZg/5d8bba79-10af-4cc8-cb10-d9b06b2c2900/public'
  }
];

const VideoStyleSelector = ({ selectedStyle, setSelectedStyle }) => {
  const selectedStyleData = styles.find(style => style.value === selectedStyle) || styles[0];

  return (
    <Menu as="div" className="relative">
      <Menu.Button className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors">
        <div className="w-6 h-6 rounded-md overflow-hidden">
          <img 
            src={selectedStyleData.image} 
            alt={selectedStyleData.label}
            className="w-full h-full object-cover"
          />
        </div>
        <span className="font-medium">{selectedStyleData.label}</span>
        <HiChevronUpDown className="w-4 h-4 text-gray-500" />
      </Menu.Button>

      <Menu.Items className="absolute bottom-full left-0 mb-2 bg-white rounded-xl shadow-xl border border-gray-200/50 p-2 focus:outline-none">
        <div className="flex gap-2 w-[600px]">
          {styles.map((style) => (
            <Menu.Item key={style.value}>
              {({ active }) => (
                <button
                  onClick={() => setSelectedStyle(style.value)}
                  className={`${
                    active ? 'bg-gray-100' : ''
                  } ${
                    selectedStyle === style.value ? 'bg-blue-50' : ''
                  } flex flex-col items-center gap-1 p-2 rounded-lg transition-colors flex-1`}
                >
                  <div className="w-20 h-20 rounded-lg overflow-hidden">
                    <img 
                      src={style.image} 
                      alt={style.label}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <span className="text-xs font-medium text-gray-900">{style.label}</span>
                </button>
              )}
            </Menu.Item>
          ))}
        </div>
      </Menu.Items>
    </Menu>
  );
};

export default VideoStyleSelector; 